import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const MachineDiagram = () => (
  <StaticImage
    src="../images/machine_diagram.jpg"
    alt="Machine Diagram"
    placeholder="blurred"
    height={480}
    objectFit="contain"
    objectPosition="left center"
  />
)

export default MachineDiagram
